export const algoliaSearchBreadcrumbComponent = {
  key: 'algoliaSearchBreadcrumbComponent',
  name: 'Algolia Search Breadcrumb Component',
  siteIdentifier: 'global',

  searchResultsBreadcrumbLabel: 'Search: {results} results for {query}',
  searchResultsWithoutQueryBreadcrumbLabel: 'Search',
  homeBreadcrumbLabel: 'Home',
};
